import { Dispatch, FC, SetStateAction } from 'react';

import { Formik, type FormikHelpers } from 'formik';
import { convertToAmount, convertStringToNumber } from 'utils/helpers';
import useModal from 'ui/partials/Modal/useModal';

import { useCreateDeal } from '../hooks';
import { DEAL_SCHEMA, DEAL_FORM } from '../forms/schema';
import NewDealForm from '../forms/NewDealForm';

const FORM_INIT = {
  name: '',
  amount: 0,
  type: '',
  contacts: [],
  pipelineId: '',
  stageId: '',
  closedAt: null,
  leadId: [],
  companyId: null,
  tagId: [],
  accountUserId: [],
};

interface PROPS {
  selectedPipelineId: string;
  form: {
    [key: string]: any;
  } | null;
  setForm: Dispatch<SetStateAction<any>>;
}

const CreateDealModal: FC<PROPS> = ({ selectedPipelineId, form, setForm }) => {
  const { hideModal } = useModal();
  const { mutate: createDeal, isLoading: createLoading } = useCreateDeal();

  const onSubmit = (
    values: DEAL_FORM,
    { setSubmitting, resetForm }: FormikHelpers<DEAL_FORM>,
  ) => {
    createDeal(
      {
        ...values,
        amount: convertStringToNumber(convertToAmount(values.amount ?? 0)),
      },
      {
        onSuccess: () => {
          hideModal();
          setForm(null);
          resetForm();
        },
        onSettled: () => {
          setSubmitting(false);
        },
      },
    );
    setForm(null);
  };

  return (
    <Formik<DEAL_FORM>
      initialValues={{
        ...FORM_INIT,
        ...form,
        pipelineId: selectedPipelineId,
        leadId:
          form?.leadId?.map((lead: string | { _id: string }) =>
            typeof lead === 'string' ? lead : lead?._id,
          ) ?? [],
      }}
      onSubmit={onSubmit}
      validationSchema={DEAL_SCHEMA}
      enableReinitialize
    >
      {() => (
        <NewDealForm
          resetForm={() => setForm(null)}
          isLoading={createLoading}
          setForm={setForm}
        />
      )}
    </Formik>
  );
};

export default CreateDealModal;
